import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { ModalDataService } from 'src/app/services/global/modal-data.service';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-are-you-sure',
  templateUrl: './are-you-sure.component.html',
  styleUrls: ['./are-you-sure.component.scss']
})
export class AreYouSureComponent implements OnInit , OnDestroy {
  message : string = '';
  buttonText : string = '';
  parentId : string = '';
  negativeText:string = 'انصراف'
  @Output() selectOptionEmiiter:EventEmitter<boolean> = new EventEmitter(false)
  
  constructor(
    public dialogRef: MatDialogRef<AreYouSureComponent>,
    public parentDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public modalService:ModalDataService,
    private globalService:GlobalService
  ) {}

  ngOnInit(): void {
    this.message = this.data.message != null ? this.data.message : 'آیا از حذف تغییرات مطمئن هستید ؟'
    this.buttonText = this.data.buttonText != null ? this.data.buttonText : 'بله'
    this.parentId = this.data.parentId != null ? this.data.parentId : ''
    this.negativeText = this.data.negativeText ? this.data.negativeText : 'انصراف'
  }

  success(){
    this.selectOptionEmiiter.emit(true)
    if(this.data.action=='delete'){
      this.modalService.is_sure = true;
      this.modalService.deletePostStatus.next(true);
    }else{
      this.dialogRef.close();
      this.parentDialog.getDialogById(this.parentId)?.close({state: 'cancel'})
      this.modalService.is_sure = false;
      this.globalService.changeScaleStatus(false)
    }
  }
  failure(){
    this.selectOptionEmiiter.emit(false)
  }
  ngOnDestroy(): void {
    this.modalService.is_sure = false;
    this.modalService.deletePostStatus = new BehaviorSubject(false);
  }
}
